import { TFunction } from 'i18next';
import { isEmpty } from 'ramda';
import { systemInfoCapabilities } from 'src/js/data/systemInfo';
import { GenericResponse } from 'src/js/model/api/response/generic-response';
import { isNilOrEmpty } from 'src/js/util/global-util';
import { alphabetic, port } from 'src/js/validator/validator';
import * as yup from 'yup';

import { getUASSecuritySelection, getUASSelection } from './metadata-security-insertion';

export enum MetadataState {
  STOPPED = 0,
  WORKING,
  FAILED,
}

export enum MetadataFormatEnum {
  KLV = 0,
  COT,
  UNKNOWNN,
}

export enum MetadataTypeEnum {
  SERIAL = 0,
  NETWORK,
  INPUT,
  UNKNOWNN,
}
export enum MetadataDecimationModeEnum {
  NONE = 'none',
  BYFACTOR = 'factor',
  WITHENCODER = 'encoder',
}

export const UasTable = [
  { id: 1, text: '1 - Checksum', minST0902: true },
  { id: 2, text: '2 - Precision Time Stamp', minST0902: true },
  { id: 3, text: '3 - Mission ID', minST0902: true },
  { id: 4, text: '4 - Platform Tail Number' },
  { id: 5, text: '5 - Platform Heading Angle', minST0902: true },
  { id: 6, text: '6 - Platform Pitch Angle', minST0902: true },
  { id: 7, text: '7 - Platform Roll Angle', minST0902: true },
  { id: 8, text: '8 - Platform True Airspeed' },
  { id: 9, text: '9 - Platform Indicated Airspeed' },
  { id: 10, text: '10 - Platform Designation', minST0902: true },
  { id: 11, text: '11 - Image Source Sensor', minST0902: true },
  { id: 12, text: '12 - Image Coordinate System', minST0902: true },
  { id: 13, text: '13 - Sensor Latitude', minST0902: true },
  { id: 14, text: '14 - Sensor Longitude', minST0902: true },
  { id: 15, text: '15 - Sensor True Altitude', minST0902: true },
  { id: 16, text: '16 - Sensor Horizontal field of View', minST0902: true },
  { id: 17, text: '17 - Sensor Vertical Field of View', minST0902: true },
  { id: 18, text: '18 - Sensor Relative Azimuth Angle', minST0902: true },
  { id: 19, text: '19 - Sensor Relative Elevation Angle', minST0902: true },
  { id: 20, text: '20 - Sensor Relative Roll Angle', minST0902: true },
  { id: 21, text: '21 - Slant Range', minST0902: true },
  { id: 22, text: '22 - Target Width', minST0902: true },
  { id: 23, text: '23 - Frame Center Latitude', minST0902: true },
  { id: 24, text: '24 - Frame Center Longitude', minST0902: true },
  { id: 25, text: '25 - Frame Center Elevation', minST0902: true },
  { id: 26, text: '26 - Offset Corner Latitude Point 1' },
  { id: 27, text: '27 - Offset Corner Longitude Point 1' },
  { id: 28, text: '28 - Offset Corner Latitude Point 2' },
  { id: 29, text: '29 - Offset Corner Longitude Point 2' },
  { id: 30, text: '30 - Offset Corner Latitude Point 3' },
  { id: 31, text: '31 - Offset Corner Longitude Point 3' },
  { id: 32, text: '32 - Offset Corner Latitude Point 4' },
  { id: 33, text: '33 - Offset Corner Longitude Point 4' },
  { id: 34, text: '34 - Icing Detected' },
  { id: 35, text: '35 - Wind Direction' },
  { id: 36, text: '36 - Wind Speed' },
  { id: 37, text: '37 - Static Pressure' },
  { id: 38, text: '38 - Density Altitude' },
  { id: 39, text: '39 - Outside Air Temperature' },
  { id: 40, text: '40 - Target Location Latitude' },
  { id: 41, text: '41 - Target Location Longitude' },
  { id: 42, text: '42 - Target Location Elevation' },
  { id: 43, text: '43 - Target Track Gate Width' },
  { id: 44, text: '44 - Target Track Gate Height' },
  { id: 45, text: '45 - Target Error Estimate - CE90' },
  { id: 46, text: '46 - Target Error Estimate - LE90' },
  { id: 47, text: '47 - Generic Flag Data 01' },
  { id: 48, text: '48 - Security Local Set', minST0902: true },
  { id: 49, text: '49 - Differential Pressure' },
  { id: 50, text: '50 - Platform Angle of Attack' },
  { id: 51, text: '51 - Platform Vertical Speed' },
  { id: 52, text: '52 - Platform Sideslip Angle' },
  { id: 53, text: '53 - Airfield Barometric Pressure' },
  { id: 54, text: '54 - Airfield Elevation' },
  { id: 55, text: '55 - Relative Humidity' },
  { id: 56, text: '56 - Platform Ground Speed' },
  { id: 57, text: '57 - Ground Range' },
  { id: 58, text: '58 - Platform Fuel Remaining' },
  { id: 59, text: '59 - Platform Call Sign' },
  { id: 60, text: '60 - Weapon Load' },
  { id: 61, text: '61 - Weapon Fired' },
  { id: 62, text: '62 - Laser PRF Code' },
  { id: 63, text: '63 - Sensor Field of View Name' },
  { id: 64, text: '64 - Platform Magnetic Heading' },
  { id: 65, text: '65 - UAS Datalink LS Version Number', minST0902: true },
  { id: 66, text: '66 - Target Location Covariance Matrix' },
  { id: 67, text: '67 - Alternate Platform Latitude' },
  { id: 68, text: '68 - Alternate Platform Longitude' },
  { id: 69, text: '69 - Alternate Platform Altitude' },
  { id: 70, text: '70 - Alternate Platform Name' },
  { id: 71, text: '71 - Alternate Platform Heading' },
  { id: 72, text: '72 - Event Start Time - UTC' },
  { id: 73, text: '73 - RVT Local Set' },
  { id: 74, text: '74 - VMTI Local Set' },
  { id: 75, text: '75 - Sensor Ellipsoid Height', minST0902: true },
  { id: 76, text: '76 - Alternate Platform Ellipsoid Height' },
  { id: 77, text: '77 - Operational Mode' },
  { id: 78, text: '78 - Frame Center Height Above Ellipsoid', minST0902: true },
  { id: 79, text: '79 - Sensor North Velocity' },
  { id: 80, text: '80 - Sensor East Velocity' },
  { id: 81, text: '81 - Image Horizon Pixel Pack' },
  { id: 82, text: '82 - Corner Latitude Point 1 (Full)' },
  { id: 83, text: '83 - Corner Longitude Point 1 (Full)' },
  { id: 84, text: '84 - Corner Latitude Point 2 (Full)' },
  { id: 85, text: '85 - Corner Longitude Point 2 (Full)' },
  { id: 86, text: '86 - Corner Latitude Point 3 (Full)' },
  { id: 87, text: '87 - Corner Longitude Point 3 (Full)' },
  { id: 88, text: '88 - Corner Latitude Point 4 (Full)' },
  { id: 89, text: '89 - Corner Longitude Point 4 (Full)' },
  { id: 90, text: '90 - Platform Pitch Angle (Full)', minST0902: true },
  { id: 91, text: '91 - Platform Roll Angle (Full)', minST0902: true },
  { id: 92, text: '92 - Platform Angle of Attack (Full)' },
  { id: 93, text: '93 - Platform Sideslip Angle (Full)' },
  { id: 94, text: '94 - MIIS Core Identifier', minST0902: true },
  { id: 95, text: '95 - SAR Motion Imagery Local Set' },
  { id: 96, text: '96 - Target Width Extended', minST0902: true },
  { id: 97, text: '97 - Range Image Local Set' },
  { id: 98, text: '98 - Geo-Registration Local Set' },
  { id: 99, text: '99 - Composite Imaging Local Set' },
  { id: 100, text: '100 - Segment Local Set' },
  { id: 101, text: '101 - Amend Local Set' },
  { id: 102, text: '102 - SDCC-FLP' },
  { id: 103, text: '103 - Density Altitude Extended' },
  { id: 104, text: '104 - Sensor Ellipsoid Height Extended', minST0902: true },
  { id: 105, text: '105 - Alternate Platform Ellipsoid Height Extended' },
  { id: 106, text: '106 - Stream Designator' },
  { id: 107, text: '107 - Operational Base' },
  { id: 108, text: '108 - Broadcast Source' },
  { id: 109, text: '109 - Range To Recovery Location' },
  { id: 110, text: '110 - Time Airborne' },
  { id: 111, text: '111 - Propulsion Unit Speed' },
  { id: 112, text: '112 - Platform Course Angle' },
  { id: 113, text: '113 - Altitude AGL' },
  { id: 114, text: '114 - Radar Altimeter' },
  { id: 115, text: '115 - Control Command' },
  { id: 116, text: '116 - Control Command Verification List' },
  { id: 117, text: '117 - Sensor Azimuth Rate' },
  { id: 118, text: '118 - Sensor Elevation Rate' },
  { id: 119, text: '119 - Sensor Roll Rate' },
  { id: 120, text: '120 - On-board MI Storage Percent Full' },
  { id: 121, text: '121 - Active Wavelength List' },
  { id: 122, text: '122 - Country Codes' },
  { id: 123, text: '123 - Number of NAVSATs in View' },
  { id: 124, text: '124 - Positioning Method Source' },
  { id: 125, text: '125 - Platform Status' },
  { id: 126, text: '126 - Sensor Control Mode' },
  { id: 127, text: '127 - Sensor Frame Rate Pack' },
  { id: 128, text: '128 - Wavelengths List' },
  { id: 129, text: '129 - Target ID' },
  { id: 130, text: '130 - Airbase Locations' },
  { id: 131, text: '131 - Take-off Time' },
  { id: 132, text: '132 - Transmission Frequency' },
  { id: 133, text: '133 - On-board MI Storage Capacity' },
  { id: 134, text: '134 - Zoom Percentage' },
  { id: 135, text: '135 - Communications Method' },
  { id: 136, text: '136 - Leap Seconds' },
  { id: 137, text: '137 - Correction Offset' },
  { id: 138, text: '138 - Payload List' },
  { id: 139, text: '139 - Active Payloads' },
  { id: 140, text: '140 - Weapons Stores' },
  { id: 141, text: '141 - Waypoint List' },
];

export const UasSecurityTable = [
  { id: 1, text: '1 - Security Classification', minST0902: true },
  {
    id: 2,
    text: '2 - Classifying Country and Releasing Instructions Country Coding Method',
    minST0902: true,
  },
  { id: 3, text: '3 - Classifying Country', minST0902: true },
  { id: 4, text: '4 - Security-SCI/SHI information', minST0902: true },
  { id: 5, text: '5 - Caveats', minST0902: true },
  { id: 6, text: '6 - Releasing Instructions', minST0902: true },
  { id: 7, text: '7 - Classified By' },
  { id: 8, text: '8 - Derived From' },
  { id: 9, text: '9 - Classification Reason' },
  { id: 10, text: '10 - Declassification Date' },
  { id: 11, text: '11 - Classification and Marking System' },
  { id: 12, text: '12 - Object Country Coding Method', minST0902: true },
  { id: 13, text: '13 - Object Country Codes', minST0902: true },
  { id: 14, text: '14 - Classification Comments' },
  { id: 15, text: '15 - UMID' },
  { id: 19, text: '19 - Stream ID' },
  { id: 20, text: '20 - Transport Stream ID' },
  { id: 21, text: '21 - Item Designator ID (16 byte)' },
  { id: 22, text: '22 - Version', minST0902: true },
  {
    id: 23,
    text: '23 - Classifying Country and Releasing Instructions Country Coding Method Version Date',
  },
  { id: 24, text: '24 - Object Country Coding Method Version Date' },
];

export const UasIds = UasTable.map((item) => item.id);
export const UasMinIds = UasTable.filter((item) => item.minST0902).map((item) => item.id);
export const UasSecurityIds = UasSecurityTable.map((item) => item.id);
export const UasSecurityMinIds = UasSecurityTable.filter((item) => item.minST0902).map((item) => item.id);

const regExpIpv6 = new RegExp(
  /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/,
);

export interface MetadataCoTRelay {
  ip: string;
  port: number;
  tos: string;
  ttl: string;
  index?: number;
}

export const newMetadataCoTRelay = (): MetadataCoTRelay => ({
  ip: '',
  port: 1025,
  tos: '',
  ttl: '',
});

export interface Metadata {
  address?: string;
  baudRate?: number;
  classifyingCountry: string;
  codingMethod: string;
  countryCodes: string;
  dataBits?: number;
  decimation?: number;
  decimationMode?: MetadataDecimationModeEnum;
  defaultName: string;
  delta?: number;
  enableCotRelay?: boolean;
  flowControl?: number;
  format: MetadataFormatEnum;
  id: number;
  interface: number;
  klvFilteringEnabled: boolean;
  klvFilteringSecurityEnabled: boolean;
  missionId: string;
  name: string;
  parity?: number;
  port?: number;
  relays?: MetadataCoTRelay[];
  securityClassification: number;
  securityInsertionEnabled: boolean;
  sensorDiscovery?: boolean;
  spiUid?: string;
  standard?: number;
  status: number | string;
  stopBits?: number;
  type: MetadataTypeEnum;
  typeTextual: string;
  uasSecurityTags: number[];
  uasTags: number[];
}

export interface MetadataStats {
  addedMissionIDs?: string;
  addedSecuritySets?: string;
  generatedKLVBytes?: string;
  generatedKLVMessages?: string;
  invalidUasMessages?: string;
  klvBitrate?: string;
  lastReset: string;
  lastTosChange?: string;
  lastTtlChange?: string;
  relays?: {
    lastRelayError: string;
    lastRelayErrorOccurred: string;
    relayedBytes: string;
    relayedMessages: string;
    relayingErrors: string;
  }[];
  rxAirCraftMessages?: string;
  rxBytes: string;
  rxCorruptMessages: string;
  rxFilteredSPIMessages?: string;
  rxOKMessages: string;
  rxSPIMessages?: string;
  rxUasMessages?: string;
  sensorUIDs?: string[];
  sourceAddress?: string;
  sourceTOS?: string;
  sourceTTL?: string;
  state: MetadataState;
  tosChanges?: string;
  ttlChanges?: string;
  updatedMissionIDs?: string;
  updatedSecuritySets?: string;
}

export const metadataIsStopped = (state: MetadataState): boolean => state === MetadataState.STOPPED;
export const metadataIsStarted = (state: MetadataState): boolean =>
  state === MetadataState.WORKING || state === MetadataState.FAILED;

export const metadataStateToIcon = (state: MetadataState): string => {
  switch (state) {
    case MetadataState.STOPPED:
      return 'StatusStopped';
    case MetadataState.WORKING:
      return 'StatusOK';
    case MetadataState.FAILED:
      return 'StatusStreamWarning';
  }
};

export const metadataStateToName = (state: MetadataState, t: TFunction): string => {
  switch (state) {
    case MetadataState.STOPPED:
      return t('metadata.states.inactive');
    case MetadataState.WORKING:
      return t('metadata.states.active');
    case MetadataState.FAILED:
      return t('metadata.states.failed');
  }
};

const metadataStateToSortable = (state: MetadataState): number => {
  switch (state) {
    case MetadataState.WORKING:
      return 1;
    case MetadataState.FAILED:
      return 2;
    case MetadataState.STOPPED:
      return 3;
  }
};

export const metadataStateToColor = (state: MetadataState): string => {
  switch (state) {
    case MetadataState.STOPPED:
      return 'haiui-gray-07';
    case MetadataState.WORKING:
      return 'haiui-green-01';
    case MetadataState.FAILED:
      return 'haiui-amber-01';
  }
};

export const metadataStateToStatus = (state: MetadataState): string => {
  switch (state) {
    case MetadataState.STOPPED:
      return 'INACTIVE';
    case MetadataState.WORKING:
      return 'ACTIVE';
    case MetadataState.FAILED:
      return 'ALERT';
  }
};

export const metadataModelToStatus = (model: MetadataViewModel): string => {
  return metadataStateToStatus(model.state);
};

export const metadataStateStatusToState = (state: MetadataState, status: number): MetadataState => {
  switch (state) {
    case MetadataState.STOPPED:
      return MetadataState.STOPPED;
    case MetadataState.WORKING:
      return status === 0 ? MetadataState.FAILED : MetadataState.WORKING;
    case MetadataState.FAILED:
      return MetadataState.FAILED;
  }
};

export const metadataFormatToText = (format: MetadataFormatEnum) => {
  switch (format) {
    case MetadataFormatEnum.KLV:
      return 'KLV';
    case MetadataFormatEnum.COT:
      return 'CoT';
    default:
      return '';
  }
};

export const metadataTypeToTypeTextual = (info: Metadata, t: TFunction) => {
  switch (info.type) {
    case MetadataTypeEnum.SERIAL:
      return t('metadata.settings.serial');
    case MetadataTypeEnum.NETWORK:
      return t('metadata.settings.network');
    case MetadataTypeEnum.INPUT:
      return `${info.typeTextual} (${systemInfoCapabilities.is2110() ? '' : 'BNC-'}${info.interface + 1})`;
    default:
      return '';
  }
};

const metadataParameters = (info: Metadata, t: TFunction) => {
  let parameters = '';

  switch (info.type) {
    case MetadataTypeEnum.SERIAL:
      if (info.format === MetadataFormatEnum.COT) {
        parameters = `${t('metadata.settings.delta')} ${info.delta} ms`;
      }
      break;

    case MetadataTypeEnum.NETWORK: {
      let addressStr = info.address;
      if (isEmpty(addressStr)) {
        addressStr = '(any)';
      } else if (addressStr && regExpIpv6.exec(addressStr)) {
        addressStr = `[${addressStr}]`;
      }

      parameters = `udp://@ ${addressStr}:${info.port}`;
      break;
    }

    case MetadataTypeEnum.INPUT:
      if (info.decimationMode === MetadataDecimationModeEnum.WITHENCODER) {
        parameters = `${t('metadata.settings.decimationMode.withEncoder')} ${info.decimation}`;
      } else if (info.decimationMode === MetadataDecimationModeEnum.BYFACTOR) {
        if (info.decimation !== 1) {
          parameters = `${t('metadata.settings.decimationMode.dividedBy')} ${info.decimation}`;
        }
      }
      break;
  }

  if (info.enableCotRelay) {
    parameters += ` (${t('metadata.settings.relayed')})`;
  }

  return parameters;
};

export const metadataName = (metadata: MetadataViewModel, t: TFunction) =>
  isNilOrEmpty(metadata.name) ? t('stream.unnamedStream') : metadata.name;

export const metadataNameOrConstructed = (metadata: MetadataViewModel, t: TFunction) => {
  let name = metadata.name;
  let address = metadata.address;
  if (name === '') {
    switch (metadata.type) {
      case MetadataTypeEnum.SERIAL: //Serial port
        name = 'Serial:' + metadataFormatToText(metadata.format);
        break;
      case MetadataTypeEnum.NETWORK:
        if (address === '') {
          address = '(any)';
        }
        if (address && address.match(regExpIpv6)) {
          address = '[' + address + ']';
        }
        name = metadataFormatToText(metadata.format) + ':udp://@' + address + ':' + metadata.port;
        break;
      case MetadataTypeEnum.INPUT: //SDI
        if (metadata.decimationMode === 'encoder') {
          name =
            metadataFormatToText(metadata.format) +
            ':BNC-' +
            (metadata.interface + 1) +
            ` ${t('metadata.settings.decimationMode.withEncoder')} ` +
            metadata.decimation;
        } else if (metadata.decimation != 1) {
          name =
            metadataFormatToText(metadata.format) +
            ':BNC-' +
            (metadata.interface + 1) +
            ` ${t('metadata.settings.decimationMode.dividedBy')} ` +
            metadata.decimation;
        } else {
          name =
            metadataFormatToText(metadata.format) +
            ':BNC-' +
            (metadata.interface + 1) +
            ` ${t('metadata.settings.decimationMode.undecimated')}`;
        }
        break;
    }
  }

  return name;
};

export const getTTL = (ttl: string): string => (ttl === '' || ttl === '-1' ? '' : ttl);

export const getTOS = (tos: string): string => (tos === '' || tos === '-1' || tos === '0xFFFFFFFF' ? '' : tos);

export const getTTLHint = (ttl: string, type: MetadataTypeEnum, edit: boolean, t: TFunction): string => {
  if (type === MetadataTypeEnum.SERIAL) {
    return edit
      ? ttl === '' || ttl === '-1'
        ? `${t('metadata.settings.ttlExplain')}`
        : t('metadata.settings.ttlExplain')
      : ttl === '' || ttl === '-1'
      ? '64'
      : ttl;
  } else {
    return edit
      ? ttl === '' || ttl === '-1'
        ? `${t('metadata.settings.ttlExplain')} (${t('metadata.settings.auto')})`
        : t('metadata.settings.ttlExplain')
      : ttl === '' || ttl === '-1'
      ? t('metadata.settings.autoDetect')
      : ttl;
  }
};

export const getTOSHint = (tos: string, type: MetadataTypeEnum, edit: boolean, t: TFunction): string => {
  if (type === MetadataTypeEnum.SERIAL) {
    return edit
      ? tos === '' || tos === '-1' || tos === '0xFFFFFFFF'
        ? `${t('metadata.settings.tosExplain')}`
        : t('metadata.settings.tosExplain')
      : tos === '' || tos === '-1' || tos === '0xFFFFFFFF'
      ? '0'
      : tos;
  } else {
    return edit
      ? tos === '' || tos === '-1' || tos === '0xFFFFFFFF'
        ? `${t('metadata.settings.tosExplain')} (${t('metadata.settings.auto')})`
        : t('metadata.settings.tosExplain')
      : tos === '' || tos === '-1' || tos === '0xFFFFFFFF'
      ? t('metadata.settings.autoDetect')
      : tos;
  }
};

export interface MetadataResponse extends GenericResponse {
  info: Metadata;
  stats: MetadataStats;
}

export interface GetAllMetadataResponse {
  data: MetadataResponse[];
}

export interface MetadataViewModel extends Metadata {
  stats?: MetadataStats;
  state: MetadataState;

  stateSortable: number;
  formatTxt: string;
  paramsTxt: string;

  status: string;

  selected: boolean /* checked by checkbox */;
  hidden: boolean /* when filtered out */;
  updated: string /* to trigger setState to detect change and re-render */;
  uasSelection: string;
  uasSecuritySelection: string;
}

export const mapMetadataViewModel = (response: MetadataResponse, t: TFunction): MetadataViewModel => ({
  ...response.info,
  stopBits: Math.max(1, response.info.stopBits),
  relays: response.info.relays || [],
  stats: { ...response.stats, sensorUIDs: response.stats.sensorUIDs || [] },
  state: metadataStateStatusToState(response.stats.state, Number(response.info.status)),

  stateSortable: metadataStateToSortable(response.stats.state),
  formatTxt: metadataFormatToText(response.info.format),
  paramsTxt: metadataParameters(response.info, t),
  typeTextual: metadataTypeToTypeTextual(response.info, t),

  status: metadataStateToStatus(response.stats.state), // required for ActionBar
  selected: false,
  hidden: false,
  updated: new Date().toISOString(),
  uasSelection: getUASSelection(response.info.uasTags),
  uasSecuritySelection: getUASSecuritySelection(response.info.uasSecurityTags),
});

export const mapMetadataResponse = (response: GetAllMetadataResponse, t: TFunction): MetadataViewModel[] => {
  if (response?.data == null) {
    return [];
  }
  const mapped = response.data.map((item) => mapMetadataViewModel(item, t));
  return mapped;
};

export const newMetadataViewModel = (_t: TFunction): MetadataViewModel => ({
  address: '',
  baudRate: 1200,
  classifyingCountry: '',
  codingMethod: 'ISO 3166-1 alpha-3',
  countryCodes: '',
  dataBits: 8,
  decimation: 0,
  decimationMode: MetadataDecimationModeEnum.NONE,
  defaultName: '',
  delta: 0,
  enableCotRelay: false,
  flowControl: 0,
  format: MetadataFormatEnum.KLV,
  id: -1,
  interface: 0,
  klvFilteringEnabled: false,
  klvFilteringSecurityEnabled: false,
  missionId: '',
  name: '',
  parity: 0,
  port: undefined,
  relays: [],
  securityClassification: 1,
  securityInsertionEnabled: false,
  sensorDiscovery: false,
  spiUid: '',
  standard: 0,
  stopBits: 1,
  type: MetadataTypeEnum.NETWORK,
  typeTextual: '',
  uasSecurityTags: [],
  uasTags: [],

  state: 0,
  stateSortable: metadataStateToSortable(0),
  formatTxt: metadataFormatToText(MetadataFormatEnum.KLV),
  paramsTxt: '',
  status: metadataStateToStatus(0),
  selected: false,
  hidden: false,
  updated: new Date().toISOString(),
  uasSelection: 'none',
  uasSecuritySelection: 'none',
});

const notMoreThanSix = (value: string) => /^(.+;.+){6,}$/.test(value) === false;

/*
 * Validation
 */
export const metadataValidationSchema = (t: TFunction) =>
  yup.object().shape({
    name: yup.string().max(63, t('validation.maxLength', { length: 63 })),
    delta: yup.number().when('format', {
      is: MetadataFormatEnum.COT,
      then: yup
        .number()
        .typeError(t('validation.metadata.delta'))
        .min(0, t('validation.metadata.delta'))
        .max(1000, t('validation.metadata.delta')),
    }),
    port: yup.number().when('type', {
      is: 1,
      then: port(t).required(t('validation.required')),
    }),
    missionId: yup.string().max(127, t('validation.maxLength', { length: 127 })),
    classifyingCountry: yup.string().when('securityInsertionEnabled', {
      is: true,
      then: alphabetic(t).required(t('validation.required')),
    }),
    countryCodes: yup.string().when('securityInsertionEnabled', {
      is: true,
      then: yup
        .string()
        .required(t('validation.required'))
        .matches(/^[a-z;A-Z]+$/, t('validation.nonAlphabetic'))
        .test('not-more-than-six', t('validation.metadata.countryCodes'), (value) => notMoreThanSix(value)),
    }),
  });

const validateTOS = (value: string) => {
  if (isNilOrEmpty(value) || Number(value) === -1 || value === '0xFFFFFFFF') {
    return true;
  }

  if (typeof value == 'string' && value.startsWith('0x')) {
    const intVal = parseInt(value, 16);
    if (Number.isNaN(intVal) || intVal >= 256) {
      return false;
    }
  }

  const tos = Number(value);
  if (Number.isNaN(tos) || tos >= 256) {
    return false;
  }

  return true;
};

const validateTTL = (value: string) => {
  if (isNilOrEmpty(value) || Number(value) === -1 || value === '0xFFFFFFFF') {
    return true;
  }

  const ttl = Number(value);
  if (Number.isNaN(ttl) || ttl <= 0 || ttl >= 256) {
    return false;
  }

  return true;
};

export const metadataCoTRelayValidationSchema = (t: TFunction) =>
  yup.object().shape({
    ip: yup.string().required(t('validation.required')),
    port: port(t).required(t('validation.required')),
    tos: yup.string().test('is-valid-tos', t('validation.outOfRange'), (value) => validateTOS(value)),
    ttl: yup.string().test('is-valid-ttl', t('validation.outOfRange'), (value) => validateTTL(value)),
  });
